export default __webpack_public_path__ + "static/media/Tesso's Honor.d2f6ce76.jpg";